import React from 'react';
import { SelectInput } from 'react-admin';
import { useTranslate } from 'react-admin';
import { getProcessingFlows } from '~/api/processingFlows';
import { useApi } from '~/hooks';

const l = (key: string): string => `components.ProcessingFlowSelect.${key}`;

const ProcessingFlowSelect = (props: any) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const [{ data, loading }] = useApi<string[]>(getProcessingFlows);
  const choices = data?.map((item) => ({ id: item, name: item }));
  if (!data) return null;
  if (loading) return null;
  return (
    <SelectInput
      source={`${props.sourceBase || ''}processing.flow`}
      choices={choices}
      allowEmpty
      label={t('processingFlow')}
    />
  );
};

export default ProcessingFlowSelect;
